import { render } from "./AboutPage.vue?vue&type=template&id=a1183a3c"
const script = {}

import exportComponent from "C:\\Users\\RebO\\Documents\\Github\\Projekt\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__